import { insertSlice } from "@ext/markdown/elements/pasteMarkdown/logic/handlePasteMarkdown";
import { Fragment, type Schema, Slice } from "@tiptap/pm/model";
import type { EditorView } from "@tiptap/pm/view";
import { handlePaste } from "prosemirror-tables";

const createTable = (schema: Schema, rows: string[][]) => {
	const { table, tableRow, tableCell, paragraph } = schema.nodes;
	const createCell = (text: string) =>
		tableCell.create(
			null,
			text.split("\n").map((line) => paragraph.create(null, line ? schema.text(line) : null)),
		);

	return table.create(
		null,
		rows.map((row) => tableRow.create(null, row.map(createCell))),
	);
};

const pasteTsvTable = (view: EditorView, rows: string[][]) => {
	const slice = new Slice(Fragment.from(createTable(view.state.schema, rows)), 0, 0);
	// Inside a table the rows go into the cells around the cursor, as when a table is pasted with its HTML.
	if (handlePaste(view, null, slice)) return;
	insertSlice(view.state.tr, view, slice);
};

export default pasteTsvTable;
